import messageActionsTypes from '../actionTypes/messageActionTypes';

const initialState = {
  messageStatus: false,
  messageLoading: false,
  chats: {},
  chatsLoading: false,
  imagesUpload: false,
  chatPageLoading: false,
};

const addChatMessage = (state, { chatId, message, setAsUnread }) => {
  // eslint-disable-next-line prefer-object-spread
  const newState = Object.assign({}, state);
  // eslint-disable-next-line array-callback-return
  newState.chats?.data.filter((chat) => chat.id === chatId).map((chat) => {
    if (setAsUnread) {
      // eslint-disable-next-line no-param-reassign
      chat.count_unread_messages = (chat.count_unread_messages || 0) + 1;
    } else {
      // eslint-disable-next-line no-param-reassign
      chat.scrollBottom = !chat.scrollBottom;
    }
    chat?.messages?.data.unshift(message);
  });
  return newState;
};

const addChatPage = (state, { chatId, data }) => {
  // eslint-disable-next-line prefer-object-spread
  const newState = Object.assign({}, state);
  // eslint-disable-next-line array-callback-return
  newState.chats?.data.filter((chat) => chat.id === chatId).map((chat) => {
    const messagesIds = chat.messages.data.map((item) => item.id);
    const newMessages = data.data.data.filter((item) => !messagesIds.includes(item.id));
    // eslint-disable-next-line no-param-reassign
    chat.scrollBottom = !chat.scrollBottom;
    // eslint-disable-next-line no-param-reassign
    chat.messages.data = [...chat.messages.data, ...newMessages];
    // eslint-disable-next-line no-param-reassign
    chat.messages.meta = data.data.meta;
  });
  return newState;
};

const readMessage = (state, { chatId, messageId }) => {
  // eslint-disable-next-line prefer-object-spread
  const newState = { ...state };
  // eslint-disable-next-line array-callback-return
  newState.chats?.data?.filter((chat) => chat.id === chatId).map((chat) => {
    if (chat?.count_unread_messages) {
      // eslint-disable-next-line no-param-reassign
      chat.count_unread_messages -= 1;
    }
    // eslint-disable-next-line array-callback-return
    chat?.messages?.data.map((item) => {
      if (item.id === messageId) {
        // eslint-disable-next-line no-param-reassign
        item.is_read = true;
      }
    });
  });
  return newState;
};

const messageReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case messageActionsTypes.SEND_MESSAGE_START:
      return {
        ...state,
        messageLoading: true,
      };
    case messageActionsTypes.SEND_MESSAGE_SUCCESS:
      return {
        ...state,
        messageStatus: payload.success,
        messageLoading: false,
      };
    case messageActionsTypes.SEND_MESSAGE_FAIL:
      return {
        ...state,
        messageLoading: false,
      };
    case messageActionsTypes.SEND_MESSAGE_STATUS_DISCARD:
      return {
        ...state,
        messageStatus: false,
      };
    case messageActionsTypes.GET_CHATS_START:
      return {
        ...state,
        chatsLoading: true,
      };
    case messageActionsTypes.GET_CHATS_SUCCESS:
      return {
        ...state,
        chats: payload.data,
        chatsLoading: false,
      };
    case messageActionsTypes.GET_CHATS_FAIL:
      return {
        ...state,
        chatsLoading: false,
      };
    case messageActionsTypes.UPLOAD_IMAGES_START:
      return {
        ...state,
        imagesUpload: true,
      };
    case messageActionsTypes.UPLOAD_IMAGES_SUCCESS:
      return {
        ...state,
        imagesUpload: false,
      };
    case messageActionsTypes.UPLOAD_IMAGES_FAIL:
      return {
        ...state,
        imagesUpload: false,
      };
    case messageActionsTypes.ADD_CHAT_MESSAGE:
      return addChatMessage(state, payload);
    case messageActionsTypes.GET_CHAT_PAGE_START:
      return {
        ...state,
        chatPageLoading: true,
      };
    case messageActionsTypes.GET_CHAT_PAGE_SUCCESS:
      return {
        ...state,
        chatPageLoading: false,
      };
    case messageActionsTypes.GET_CHAT_PAGE_FAIL:
      return {
        ...state,
        chatPageLoading: false,
      };
    case messageActionsTypes.ADD_CHAT_PAGE:
      return addChatPage(state, payload);
    case messageActionsTypes.READ_QUESTIONS_MESSAGE_SUCCESS:
      return readMessage(state, payload);
    default:
      return state;
  }
};

export default messageReducer;
